import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Path from '../../Path';
import { useLanguage } from '../../i18n/useLanguage';
import Seo from '../seo/Seo';

/** Vraie page 404 (noindex) plutôt qu'une redirection silencieuse, qui serait un "soft 404". */
export default function NotFoundPage() {
    const { t } = useTranslation();
    const { localize } = useLanguage();

    return (
        <div className="mx-auto max-w-2xl p-6">
            <Seo title={t('notFound.title')} description={t('notFound.description')} noIndex />
            <h1 className="text-2xl font-semibold">{t('notFound.title')}</h1>
            <p className="mt-2">{t('notFound.description')}</p>
            <Link className="mt-4 inline-block underline" to={localize(Path.MAP)}>
                {t('notFound.backHome')}
            </Link>
        </div>
    );
}
